<template>
  <ResponsiveModal
    :variant="variant"
    :title="$t('components.task_details.share.title')"
    :description="
      !maxSmall ? $t('components.task_details.share.description') : undefined
    "
    :showFooter="maxSmall"
    :confirmLabel="$t('components.task_details.share.link')"
    @confirm="copyTaskUrl"
  >
    <slot />
    <template #content>
      <div v-if="!maxSmall" class="h-5" />
      <div
        class="flex flex-col md:flex-row grow gap-4 md:gap-2 py-6 md:pt-0 px-4 md:px-6"
      >
        <div v-if="maxSmall" class="flex flex-col items-center">
          <span class="text-center">
            {{ $t("components.task_details.share.description_mobile") }}
          </span>
        </div>
        <TextInput
          v-model="shareTaskUrl"
          :class="maxSmall ? 'w-full' : 'grow'"
        />
        <Button
          v-if="!maxSmall"
          size="md"
          variant="tertiary"
          type="grey"
          @click="copyTaskUrl"
        >
          <Icon
            v-if="success"
            name="checkmark-default"
            size="lg"
            class="text-success-primary"
          />
          <Icon v-else name="copy" size="lg" />
        </Button>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import route from "ziggy-js";
import { ref } from "vue";
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { TextInput } from "@/SharedComponents/Inputs";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { toast } from "@/SharedComponents/Toaster";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { useI18n } from "vue-i18n";

const { maxSmall } = useBreakpoints();
const { t } = useI18n();

const props = defineProps({
  variant: { type: String, required: false },
  task: { type: Object, required: true },
});

const shareTaskUrl = ref(route("share.task", props.task));
const success = ref(false);

const copyTaskUrl = () => {
  navigator.clipboard.writeText(shareTaskUrl.value).then(() => {
    toast.success(t("toasts.link_copied"));
    success.value = true;
  });
};
</script>
